<forge-inline-message [attr.theme]="theme">
    <div>{{value}}</div>
</forge-inline-message>